import { render } from "./CreateCompanyComponent.vue?vue&type=template&id=6557868c"
import script from "./CreateCompanyComponent.vue?vue&type=script&lang=js"
export * from "./CreateCompanyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__